import React from 'react';
import styles from './docs.module.scss';
import DocsView from './docsView';

const Docs = () => {

    return (
      <div className={styles.docsDiv}>
          <h2>Docs</h2>

          <div>
            <DocsView />
          </div>
      </div>
    );
};

export default Docs;